<div [@fadeInOut] class="loading-shade" *ngIf="isLoading">
    <div class="loader"></div>
</div>
<router-outlet></router-outlet>